import React, { useEffect, useState } from "react";
import { Heading, Center } from "@chakra-ui/react";
import { BsGithub, BsLinkedin, BsPerson } from "react-icons/bs";



export const Projects = () => {
  const project = [
    {
      disc: "This project is about A robust API that provides over 14 tested, actionable data endpoints that can empower traders, bots, and platforms. Our reliable data helps you make more informed trading decisions with less effort and has been rigorously tested to ensure accuracy.",
      github: "/",
      id: 9,
      img_src: "img/data_api.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://developers.tokenmetrics.com/",
      tech: "Node, Express, snowflake, DynamoDB",
      title: "Cryptocurrency APIs"
    },
    {
      disc: "This project is about building an online E-commerce web application with backend integration showing the functionality of an e-commerce website with JWT and Payment Gateway  etc",
      github: "https://github.com/VishalBhuse/E-Commerce-Repo",
      id: 8,
      img_src: "img/e-shop.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://ecommercemernapp.vercel.app/",
      tech: "React Redux Node Chakra-UI Express Mongodb",
      title: "E-Shop (E-Commerce)"
    },
    {
      disc: "This project is about building an online E-commerce web application with backend integration showing the functionality of an e-commerce website like filtering the products, darkmode, add to cart, wishlist etc",
      github: "https://github.com/rohaantelangur/Masai_Project_1_BigBasket",
      id: 1,
      img_src: "img/2.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://rohaantelangur.github.io/Masai_Project_1_BigBasket/",
      tech: "HTML, CSS, JavaScript",
      title: "BigBasket Clone"
    },
    {
      disc: "This project is about building an online E-commerce web application with backend integration showing the functionality of an e-commerce website like filtering the products, darkmode, add to cart, wishlist etc",
      github: "https://github.com/rohaantelangur/IndiaMart_Clone",
      id: 2,
      img_src: "img/3.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://rohaantelangur.github.io/IndiaMart_Clone/",
      tech: "HTML, CSS, JavaScript",
      title: "IndiaMart Clone"
    },
    {
      disc: "This project is about building an online E-commerce web application with backend integration showing the functionality of an e-commerce website like filtering the products, darkmode, add to cart, wishlist etc",
      github: "https://github.com/rohaantelangur/Modesens",
      id: 3,
      img_src: "img/1.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://modesensteamclone.netlify.app/",
      tech: "React, JavaScript, Chakra UI",
      title: "Modesen Clone"
    },
    {
      disc: "This project is about building an online Todos List web application with backend integration showing the functionality like filtering, Sorting the Todos, Add, Remove, Mark as Complateed Todos, Subtodos etc",
      github: "https://github.com/rohaantelangur/React_Redux_Advance_Todo_List",
      id: 4,
      img_src: "img/todos.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://react-redux-advance-todo-list.vercel.app/",
      tech: "React, Redux, Chakra UI",
      title: "Todos List"
    },
    {
      disc: "This project is about building an online Tic-Tac-Tao Game web application with React and showing the functionality like Complex DSA problem solving skills, Working with 2D array and understanding the 2D array rtc",
      github: "https://github.com/rohaantelangur/React-Tic-Tac-Tao",
      id: 5,
      img_src: "img/ttt.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://rohaantelangur.github.io/React-Tic-Tac-Tao",
      tech: "React, CSS",
      title: "Tic-Tac-Tao"
    },
    {
      disc: "This project is about building an online Slide Puzzle Game web application with HTML, CSS & JavaScripts to showing the functionality like Complex DSA problem solving skills, Working with Drag & Drop, Array etc",
      github: "https://github.com/rohaantelangur/SLIDE_PUZZLE_GAME",
      id: 6,
      img_src: "img/slide_puzzle.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://rohaantelangur.github.io/SLIDE_PUZZLE_GAME/",
      tech: "HTML, CSS, JavaScript",
      title: "Slide Puzzle Game"
    },
    {
      disc: "In that game I am try to build Cards Game it that Game Card 52 Cards divided in 5 set and player pic 5 Card from that for more Details check Github.",
      github: "https://github.com/rohaantelangur/WHETHER-APP",
      id: 9,
      img_src: "img/cardGame.png",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://game-lovat-three.vercel.app/",
      tech: "React",
      title: "Card Game"
    },
    {
      disc: "Weatherapp is a simple weather forecast app, which uses some APIs to fetch 5 day / 3 hour forecast data from the OpenWeatherMap and to fetch places,cities,counties,coords etc. from Algolia Places.",
      github: "https://github.com/rohaantelangur/WHETHER-APP",
      id: 7,
      img_src: "img/Wheather-app.jpeg",
      linkdian: "https://www.linkedin.com/in/rohan-telangur/",
      live: "https://rohaantelangur.github.io/whether-app/",
      tech: "HTML, CSS, JavaScript",
      title: "Whether App"
    }
  ]


  return (
    <div className="pt-5" id="project">
      <div className="container pt-3" >
        <Center >
          <Heading textAlign={"center"}>
            My Creative
            <span style={{ color: "rgb(220, 20, 60)" }}> Portfolio </span>
            Section
          </Heading>
        </Center>

        {/* <div className="text-center ">
          <button
            type="button"
            className="btn btn-danger px-2 fw-bold my-5 mx-3"
          >
            All
          </button>
          <button
            type="button"
            className="btn btn-danger px-2 fw-bold my-5 mx-3"
          >
            React
          </button>
          <button
            type="button"
            className="btn btn-danger px-2 fw-bold my-5 mx-3"
          >
            MERN
          </button>
          <button
            type="button"
            className="btn btn-danger px-2 fw-bold my-5 mx-3"
          >
            HTML
          </button>
        </div> */}

        <div className="row mt-5">
          {project?.map((item) => {
            return (
              <div className="col-lg-4 col-xl-4 col-md-12" key={item.id}>
                <div
                  className="card rounded p-3 mb-5"
                >
                  <img
                    src={item.img_src}
                    className="card-img-top"
                    style={{ height: "150px" }}
                    alt="..."
                  />
                  <div className="card-body">
                    <h4 className="card-title fw-bold fs-4">{item.title}</h4>
                    <p className="card-text">{item.disc}</p>
                    <p className="mt-3 fs-6">
                      <span
                        className="fw-bold"
                        style={{ color: "rgb(220, 20, 60)" }}
                      >
                        Tech Stack:{" "}
                      </span>
                      {item.tech}
                    </p>
                    <div className="d-flex justify-content-evenly">
                      <a href={item.linkdian} target="_blank">
                        <button className="mt-4 btn btn-lg btn-danger fs-2 p-2">
                          <BsLinkedin />
                        </button>
                      </a>

                      <a href={item.live} target="_blank">
                        <button className="mt-4 btn btn-lg btn-danger fs-2 p-2">
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 576 512"
                            focusable="false"
                            className="chakra-icon css-wmxkd2"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                          </svg>
                        </button>
                      </a>

                      <a href={item.github} target="_blank">
                        <button className="mt-4 btn btn-lg btn-danger fs-2 p-2">
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 496 512"
                            focusable="false"
                            className="chakra-icon css-wmxkd2"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path>
                          </svg>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
